import LoadingComponent from './Loading.component';

export default function LoadingContainer() {
  return (
    <LoadingComponent />
  );
}
